var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-silver"},[_c('h4',{class:_vm.titleClass},[_vm._v(_vm._s(_vm.day))]),_c('IconClose',{staticClass:"my-2px",attrs:{"width":17,"height":17}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }